    /*
    Name: YouTubePopUp
    Description: jQuery plugin to display YouTube or Vimeo video in PopUp, responsive and retina, easy to use.
    Version: 1.0.3
    Plugin URL: http://wp-time.com/youtube-popup-jquery-plugin/
    Written By: Qassim Hassan, Modified By: ModeEffect
    Twitter: @QQQHZ
    Websites: wp-time.com | qass.im | wp-plugins.in
    Dual licensed under the MIT and GPL licenses:
        http://www.opensource.org/licenses/mit-license.php
        http://www.gnu.org/licenses/gpl.html
    Copyright (c) 2016 - Qassim Hassan
*/

(function ( $ ) {

    $.fn.YouTubePopUp = function(options) {

        var YouTubePopUpOptions = $.extend({
                autoplay: 1
        }, options );

        $(this).on('click', function (e) {

            var videoLink = $(this).attr("href");

            // If this is a my-download video link, just use it, will be redirect to embed link
            if( videoLink.match(/^\/my-download\//gi) ) {

                videoEmbedLink = videoLink;

            // Not a my download, check for YouTube or Vimeo link
            } else {

                if( videoLink.match(/(youtube.com)/) ) {
                    var split_c = "v=";
                    var split_n = 1;
                }

                if( videoLink.match(/(youtu.be)/) || videoLink.match(/(vimeo.com\/)+[0-9]/) ) {
                    var split_c = "/";
                    var split_n = 3;
                }

                if( videoLink.match(/(vimeo.com\/)+[a-zA-Z]/) ) {
                    var split_c = "/";
                    var split_n = 5;
                }

                var getYouTubeVideoID = videoLink.split(split_c)[split_n];

                var cleanVideoID = getYouTubeVideoID.replace(/(&)+(.*)/, "");

                if( videoLink.match(/(youtu.be)/) || videoLink.match(/(youtube.com)/) ){
                    var videoEmbedLink = "https://www.youtube.com/embed/"+cleanVideoID+"?modestbranding=1&origin="+document.location.hostname+"&rel=0&autoplay="+YouTubePopUpOptions.autoplay+"";
                }

                if( videoLink.match(/(vimeo.com\/)+[0-9]/) || videoLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
                    var videoEmbedLink = "https://player.vimeo.com/video/"+cleanVideoID+"?byline=false&title=false&portrait=false&autoplay="+YouTubePopUpOptions.autoplay+"&modestbranding=1&rel=0";
                }

            }

            // No embed link defind, unsupported video url, bail here
            if( ! videoEmbedLink ) {
                return;
            }

            // We have embed link, stop default click action
            e.preventDefault();

            // Add the iframe modal
            $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+videoEmbedLink+'" frameborder="0"  allow="autoplay *; fullscreen *" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div></div>');

            if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ) {
                setTimeout(function() {
                    $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
                }, 600);
            }

            // On frame close, remove the modal
            $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function() {
                e.preventDefault();
                e.stopImmediatePropagation();

                $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() {
                    $(this).remove();
                });
            });

        });

        // On escape key, close any open modals
        $(document).keyup(function(e) {
            if ( e.keyCode == 27 ) {
                $('.YouTubePopUp-Close').click();
            }
        });

    };

}( jQuery ));
